import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from "../interfaces/SAAC/PeriodoAcademicoDTO";
import { SolicitudItinerarioDTO } from "../interfaces/Itinerario/SolicitudItinerarioDTO";
import { SolicitudEstudianteItinerarioDTO, VoidSolicitudEstudianteItinerarioDTO } from "../interfaces/Itinerario/SolicitudEstudianteItinerarioDTO";
import { TblDecInvProyectoTesistum } from "../interfaces/Itinerario/TblDecInvProyectoTesistum";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Itinerario';

export default class ItinerarioService {
    async ListSolicitudesByPeriodo(token: any, termino: string, anio: string): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/ListSolicitudesByPeriodo/' + termino + '&' + anio,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    async ListSolicitudesEstudiantesItinerarioByProyecto(token: any, idproyecto: number): Promise<ResponceApi<SolicitudItinerarioDTO>> {
        const response1: AxiosResponse<ResponceApi<SolicitudItinerarioDTO>> = await axios.get(localBack + APICATALOGO + '/ListSolicitudesEstudiantesItinerario/' + idproyecto,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    async GetSolicitudItinerarioById(token: any, idproyectoitinerario: number): Promise<ResponceApi<SolicitudEstudianteItinerarioDTO>> {
        const response1: AxiosResponse<ResponceApi<SolicitudEstudianteItinerarioDTO>> = await axios.get(localBack + APICATALOGO + '/GetSolicitudItinerarioById/' + idproyectoitinerario,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }
    async PostSolicitudItinerarioById(token: any, data: SolicitudEstudianteItinerarioDTO): Promise<ResponceApi<SolicitudEstudianteItinerarioDTO>> {
            const response: AxiosResponse<ResponceApi<SolicitudEstudianteItinerarioDTO>> = await axios.post(localBack + APICATALOGO + '/PostSolicitudItinerarioById', data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
    }
    async UpdateSolicitudItinerarioById(token: any, data: SolicitudEstudianteItinerarioDTO): Promise<ResponceApi<SolicitudEstudianteItinerarioDTO>> {
            //console.log('Crear: ' + JSON.stringify(data));
            const response: AxiosResponse<ResponceApi<SolicitudEstudianteItinerarioDTO>> = await axios.post(localBack + APICATALOGO + '/UpdateSolicitudItinerarioById', data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response.data;
    }
    // async GetPeriodoAcademicoEnEjecucion(token: any): Promise<ResponceApi<PeriodoAcademicoDTO>> {
    //     try {
    //         const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/GetPeriodoAcademicoEnEjecucion',
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`
    //                 }
    //             });
    //         //console.log(response1.data);        
    //         return response1.data;
    //     } catch (error) {
    //         console.error('Error al enviar la solicitud:', error);
    //         return {
    //             status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetPeriodoAcademicoEnEjecucion'] },
    //             operation: 0,
    //             statusCode: 500,
    //             count: 0,
    //             listData: [],
    //             data: VoidPeriodoAcademicoDTO(),
    //         };
    //     }
    // }
    async DeleteSolicitudEstudianteItinerario(idproyectotesista: number, token: any): Promise<ResponceApi<TblDecInvProyectoTesistum>> {
        try {
          // var formData = new FormData();
          const response: AxiosResponse<ResponceApi<TblDecInvProyectoTesistum>> = await axios.delete(
            localBack + APICATALOGO + '/DeleteSolicitudEstudianteItinerario/' + idproyectotesista,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data) {
            let resp = response.data;
            //console.log(resp.strEstado);
            return resp;
          } else {
            throw new Error('No se recibieron datos válidos.');
          }
        } catch (error) {
          console.error('Error al enviar la solicitud:', error);
          throw error; // Re-lanzar el error para que se maneje donde se llama a la función
        }
    }
}